import styled from 'styled-components';
import variables from '../../../styles/variables';

// GENERAL BLADE STYLES
export const Wrapper = styled.div`
  width: 100%;
  height: auto;
`;

export const BladeTitle = styled.h2`
  color: ${variables.colorRed};
  width: 100%;
  font-size: 40px;
  font-weight: 600;
  line-height: 45px;
  margin-bottom: 0;
`;

export const SectionWrapper = styled.div`
  margin-top: 40px;
`;

export const BladeSubtitle = styled.h3`
  color: ${variables.colorBlack};
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 10px;
  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

export const PhoneTitle = styled.h1`
  font-weight: 600;
  margin-bottom: 47px;
  width: 100%;
  text-transform: none;
  font-size: 24px;
  line-height: 27px;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

export const LegalText = styled.p`
  font-size: 12px;
  text-align: center;
`;

export const CarrierWrapper = styled.div`
  margin-top: 30px;
`;

export const ActionsWrapper = styled.div`
  margin-top: 72px;
  display: flex;
  justify-content: center;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    margin-top: 47px;
  }
`;

interface ButtonProps {
  isPrimary: boolean;
}

export const Button = styled.button<ButtonProps>`
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.64px;
  height: 53px;
  cursor: pointer;
  border: none;
  background: ${({ isPrimary }) => isPrimary ? variables.colorRed : variables.colorWhite};
  color: ${({ isPrimary }) => isPrimary ? variables.colorWhite : variables.colorBlack};
  border-radius: 26px;
  box-shadow: ${({ isPrimary }) => isPrimary
    ? '0 2px 4px 0 rgba(53, 43, 43, 0.24),    0 2px 4px 0 rgba(238, 46, 36, 0.49)'
    : '0 2px 4px 0 rgb(0 0 0 / 16%)'};
  margin: 5px;
  transition: all 0.3s;
  ${({ isPrimary }) => isPrimary
    ? "&:hover {background: variables.colorWhite; color: variables.colorRed;box-shadow: '0 2px 4px 0 rgba(0, 0, 0, 0.16)';}"
    : ''};
  @media screen and (max-width: 768px) {
    width: 250px;
    :nth-child(even) {
      margin-top: 50px;
    }
  }
`;

export const GridWrapper = styled.div`
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: 'empty reserve spinner';
  align-items: center;
`;

export const ButtonText = styled.div`
  grid-area: reserve;
  justify-self: center;
`;

export const CarrierLabel = styled.div`
  margin-bottom: 11px;
`;
